// this file added by Bearer Web Developer
import React, { useEffect } from "react";
import BearerMapProvider from "../../map/BearerMapApi/BearerMapProvider";
import { Location, useAppState } from "../../../states/app-state";
import { useThemeMode } from "../../../states/contexts/theme";
import { AdvancedMarker, Map, useMap } from '@vis.gl/react-google-maps';
import OriginIcon from "../../../assets/images/origin-map.png";
import OriginIconDarkMode from "../../../assets/images/origin-map-dark-mode.svg"; // added by Bearer Web Developer
interface IGoogleMapProps {
    location?: Location;
}
const MapApi: React.FC<IGoogleMapProps> = ({ location }) => {

    const appState = useAppState();
    const environmentCode = appState.environmentCode;
    const mapId = environmentCode === "STAGING" ? "f4e86786fbb6b3bb" :
        environmentCode === "PRODUCTION" ? "683a7c74fe921546" : "39e429275f5344f2";

    const { theme: themeMode } = useThemeMode(); // added by Bearer Web Developer
    const map = useMap();

    const options: google.maps.MapOptions = {
        zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_CENTER,
        } as google.maps.ZoomControlOptions,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        panControl: false,
        rotateControl: false,
        fullscreenControl: false,
        // Update while changing STAGE
        mapId: mapId,
        // ...otherOptions
    }
    const bounds = new google.maps.LatLngBounds();
    if (location) bounds.extend(location);
    else bounds.extend({ lat: -37.813628, lng: 144.963058, })

    const literalBounds = bounds.toJSON(); // added by Bearer Web Developer
    // modified by Bearer Web Developer start - add useEffect and dependencies
    useEffect(() => {
        if (map) {
            map?.setOptions(options)
            map?.fitBounds(literalBounds);
        }
    }, [map, location]);
    // modified by Bearer Web Developer end
    return (
        <Map
            colorScheme={themeMode === 'dark' ? 'DARK' : 'LIGHT'} // added by Bearer Web Developer
            style={{ width: '100%', height: '100%' }}
            defaultCenter={{ lat: -37.813628, lng: 144.963058 }}
            defaultBounds={literalBounds}
            defaultZoom={17}
            disableDefaultUI
        >
            {location &&
                <AdvancedMarker
                    anchorLeft="-30%"
                    anchorTop="-52%"
                    position={location}
                >
                    <img
                        src={themeMode === "dark" ? OriginIconDarkMode : OriginIcon} // OriginIconDarkMode and themeMode condition added by Bearer Web Developer}
                        width={40}
                        height={68}
                        alt=""
                    />
                </AdvancedMarker>   
            }
        </Map>
    );
};

const FavouritePlaceMapApi: React.FC<IGoogleMapProps> = ({ location }) => {
    return (<BearerMapProvider><MapApi location={location} /></BearerMapProvider>)
}

export default FavouritePlaceMapApi